declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: any
  }
}

export function initMetaPixel() {
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = document.getElementsByTagName('script')[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', '953408600553449')
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Protocolo Adiós Deudas Chile 2025',
      content_type: 'product',
      value: 6.37,
      currency: 'USD',
    })
  }
}
